import { StringMap } from '../common/interfaces/stringMap';
import { AM_API_DOMAINS, AM_API2_DOMAINS, EXPERIENCE_DOMAIN_CONFIG, EXPERIENCE_HOSTNAMES } from './domainConfig';

const playerApiDomain = process.env.REACT_APP_PLAYER_API_DOMAIN || '';
const experienceApiDomain = process.env.REACT_APP_EXPERIENCE_LITE_API_DOMAIN || '';
const videoFeedbackApiDomain = process.env.REACT_APP_VIDEO_FEEDBACK_API_DOMAIN || '';
const cdnPath = process.env.REACT_APP_CDN_TC || '';

const hostname = window.location.hostname as EXPERIENCE_DOMAIN_CONFIG;
const environment = EXPERIENCE_HOSTNAMES[hostname];
const amcatApiDomain = AM_API_DOMAINS[environment];
const amcatApiDomain2 = AM_API2_DOMAINS[environment];

const isDev = process.env.NODE_ENV === 'development';

const surveyQuestionsDevUrl = 'https://ew1-d1-dev1-ecs-gateway-public.shl.zone/mfs-api/questions/start';
// const surveyQuestionsDevUrl = './src/__mockData__/surveyQuestions.json';

export const apiUrls: StringMap = {
  ICP_RECORDAL_CHINA: 'http://www.miibeian.gov.cn/',
  POST_HEADER_DETAILS: `${playerApiDomain}/player/workflow/getheadersresponse`,

  // Authentication
  CUSTOM_SIGNUP_FIELDS: `${playerApiDomain}/player/workflow/customregistrationfields`,
  LOGIN: `${playerApiDomain}/player/workflow/processlogin`,
  LOGOUT: `${playerApiDomain}/player/resources/shl_security_logout`,
  RESET_PASSWORD: `${playerApiDomain}/player/vrforgotcandidatepassword`,
  CHANGE_PASSWORD: `${playerApiDomain}/player/vrchangecandidatepassword`,
  GET_PRIVACY_POLICY_JSON: `${cdnPath || playerApiDomain}/player/resources/json/privacypolicy.json`,

  // Profile
  GET_CANDIDATE_PROFILE: `${playerApiDomain}/player/candidateprofile/getcandidateprofile`,
  UPDATE_CANDIDATE_PROFILE: `${playerApiDomain}/player/candidateprofile/manageprofile`,

  // SSO
  POST_SSO_OAUTH_URL: `${playerApiDomain}/player/shloauth2`,
  POST_SSO_DETAILS: `${playerApiDomain}/player/workflow/getssodetails`,
  POST_SSO_PROCESS_OAUTH_LOGIN: `${playerApiDomain}/player/workflow/processoauthlogin`,

  // DPN
  POST_DATA: `${playerApiDomain}/player/workflow/getdata`,
  GET_DPN_DETAILS: `${playerApiDomain}/player/experience/dpn/details`,
  PROCESS_DPN: `${playerApiDomain}/player/workflow/processdpn`,

  // Workflow Configurable Pages
  GET_RESEARCH_QUESTIONS_DATA: `${amcatApiDomain2}/api/company/get-additional-features`,
  SAVE_CEPAGE_DATA: `${amcatApiDomain2}/api/company/save-additional-forms-data`,
  GET_EEO_FORM_DATA: `${amcatApiDomain2}/api/company/get-additional-features`,
  GET_OFCCP_DATA: `${amcatApiDomain2}/api/company/get-additional-features`,

  // Workflow
  GET_TEMPLATE_SETTINGS: `${playerApiDomain}/player/api/v1/workflowtemplate`,
  GET_TEMPLATE_SETTINGS_TCPLUS: `${experienceApiDomain || '/epl'}/api/v1/template/template-settings`,
  REVALIDATE_SESSION: `${experienceApiDomain || '/epl'}/api/v1/workflow`,
  POST_EXPERIENCE_INIT: `${experienceApiDomain || '/epl'}/api/v1/workflow`,
  POST_NEXT_WORKFLOW_ITEM: `${experienceApiDomain || '/epl'}/api/v1/workflow/next`,
  POST_WORKFLOW_END: `${experienceApiDomain || '/epl'}/api/v1/workflow/finish`,

  // Tasklist
  INITIALIZE_TASK: `${experienceApiDomain || '/epl'}/api/v1/tasklist/item`,
  GET_SCHEDULABLE_ASSESSMENTS: `${experienceApiDomain || '/epl'}/api/v1/schedule/details`,

  // Assessment
  GET_ASSESSMENT_DETAIL: `${experienceApiDomain || '/epl'}/api/v1/assessment`,
  POST_VALIDATE_ASSESSMENT_LAUNCH: `${experienceApiDomain || '/epl'}/api/v1/assessment/launch/validate`,
  POST_VALIDATE_ASSESSMENT: `${experienceApiDomain || '/epl'}/api/v1/assessment/launch`,
  POST_ASSESSMENT_END: `${experienceApiDomain || '/epl'}/api/v1/assessment/end`,

  // Video Feedback
  POST_VIDEO_FEEDBACK: `${videoFeedbackApiDomain}/vrs/video-feedback`,
  POST_FEEDBACK_REDIRECTION_URL: `${experienceApiDomain || '/epl'}/api/v1/generate/feedback-link`,
  GET_VIDEO_FEEDBACK_GENERATION_REQUEST_STATUS: `${experienceApiDomain || '/epl'}/api/v1/feedback-report/status`,

  // Quiz
  DUMMY_CANDIDATE_SIGNUP: `${experienceApiDomain || '/epl'}/api/v1/quiz/signup`,
  GET_QUIZ_FEEDBACK: `${experienceApiDomain || '/epl'}/api/v1/quiz/item/{id}/feedback`,

  // Proctoring
  GET_PROCTORING_CONFIG_URL: `${experienceApiDomain || '/epl'}/api/v1/workflow-context/proctoring`,
  POST_ACCEPT_CONSENT_URL: `${playerApiDomain}/player/workflow/process-remote-proctoring`,

  // hotjar survey
  GET_SURVEY_TRIGGER_CODES: `${playerApiDomain}/player/hotjar-survey/getsurveytriggercodes`,

  // SHL App
  APP_FIREBASE_URL: `${experienceApiDomain || '/epl'}/api/v1/am-firebase-url`,
  APP_MOBILE_START: `${playerApiDomain}/player/testdriver/mobile/start`,
  APP_COMBINAION_OF_DESKTOP_PLUS_MOBILE_OR_MOBILEAPP: `${playerApiDomain}/player/candidateassessment/is-desktop-only`,
  APP_RESEND_EMAIL_INVITE: `${playerApiDomain}/player/email/resend-invite`,

  /* TC PLUS */
  VALIDATE_TC_PLUS_LINK: `${experienceApiDomain || '/epl'}/api/v1/link`,
  POST_ASSESSMENT_REGISTER: `${experienceApiDomain || '/epl'}/api/v1/assessment/register`,
  REGISTER_ASSESSMENT_AMCAT: `${amcatApiDomain}/api/v1/user/register`,
  FORGOT_PASSWORD_TCPLUS: `${experienceApiDomain || '/epl'}/api/v1/auth/forgot-password`,
  CHANGE_PASSWORD_TCPLUS: `${experienceApiDomain || '/epl'}/api/v1/auth/reset-password`,
  TC_PLUS_GET_DPN: `${amcatApiDomain}/api/v1/content/getConfigEntities/`,
  SAVE_TC_PLUS_DPN: `${experienceApiDomain || '/epl'}/api/v1/dpn/save`,
  // Authentication
  TC_PLUS_CUSTOM_SIGNUP_FIELDS: `${amcatApiDomain2}/api/company/get-custom-registration-fields`,
  TC_PLUS_LOGIN: `${experienceApiDomain || '/epl'}/api/v1/auth/login`,
  TC_PLUS_LOGOUT: `${experienceApiDomain || '/epl'}/api/v1/auth/logout`,
  TCPLUS_UPDATE_FORM_STATUS: `${experienceApiDomain || '/epl'}/api/v1/form/form-status `,
  // Company Settings
  GET_COMPANY_SETTINGS: `${amcatApiDomain2}/api/company/get-company-config`,

  // Application Form
  APPLICATION_FORM_DATA: `${amcatApiDomain2}/api/company/get-registration-fields`,
  GET_COUNTRY_LIST: `${amcatApiDomain}/api/v1/content/get-country-list`,
  GET_UNIVERSITY_LIST: `${amcatApiDomain}/api/v1/content/get-university-list`,
  GET_DEGREE_LIST: `${amcatApiDomain}/api/v1/content/get-degree-list/degreeType/{degreeType}`,
  GET_STATE_LIST: `${amcatApiDomain}/api/v1/content/get-state-list`,
  GET_CITY_LIST: `${amcatApiDomain}/api/v1/content/get-city-list`,
  GET_COLLEGE_LIST: `${amcatApiDomain}/api/v1/content/get-college-list`,
  GET_SUBJECT_LIST: `${amcatApiDomain}/api/v1/content/get-subject-list`,

  // country listing
  TC_PLUS_COUNTRY_LIST: `${amcatApiDomain2}/api/company/get-country-list`,
  //user-profile
  TCPLUS_CANDIDATE_PROFILE: `${experienceApiDomain || '/epl'}/api/v1/auth/user-profile`,
  // fetch navigation languages
  TC_PLUS_LANGUAGES: `${experienceApiDomain || '/epl'}/api/v1/template`,
  // tc plus autologin ( for integrated user)
  TC_PLUS_AUTOLOGIN: `${experienceApiDomain || '/epl'}/api/v1/auth/auto-login`,

  // Basic workflow
  GET_BASIC_TASKLIST_DETAILS: `${experienceApiDomain || '/epl'}/api/v1/tasklist/details`,
  GET_CANDIDATE_MESSAGES: `${amcatApiDomain2}/api/company/get-candidate-messages`,

  // MFS Authentication
  GET_MFS_LOGIN_DETAILS: isDev
    ? './src/__mockData__/mfsLoginDetails.json'
    : `${playerApiDomain}/player/shl360/logindetails`,

  // Account
  GET_CURRENT_ACCOUNT: isDev ? './src/__mockData__/mfsCurrentAccount.json' : `${playerApiDomain}/mfs-api/account/`,
  GET_LINKED_ACCOUNTS: isDev ? './src/__mockData__/mfsLinkedAccounts.json' : `${playerApiDomain}/mfs-api/account/links`,
  POST_CHANGE_ACCOUNT: `${playerApiDomain}/mfs-api/account/change/{accountId}`,
  GET_ACCOUNT_LANGUAGES: isDev
    ? './src/__mockData__/mfsAccountLanguages.json'
    : `${playerApiDomain}/mfs-api/account/{accountId}/languages`,
  POST_SESSION_LANGUAGE: `${playerApiDomain}/mfs-api/users/session-language`,

  // Survey Questions
  GET_MANAGER_START: `${playerApiDomain}/player/shl360/remove/ratingrequest/{id}`,
  GET_SURVEY_QUESTIONS: isDev ? surveyQuestionsDevUrl : `${playerApiDomain}/mfs-api/v2/questions/start`,
  GET_SURVEY_PREVIEW_QUESTIONS: isDev ? surveyQuestionsDevUrl : `${playerApiDomain}/mfs-api/v2/questions/preview`,
  POST_SURVEY_ANSWERS: `${playerApiDomain}/mfs-api/responses`,

  GET_CUSTOM_THANKYOU_MESSAGE: isDev
    ? './src/__mockData__/thankyouMessage.json'
    : `${playerApiDomain}/mfs-api/customizations?type=thankyou`,
  GET_CUSTOM_MANAGER_START_MESSAGE: isDev
    ? './src/__mockData__/managerStartMessage.json'
    : `${playerApiDomain}/mfs-api/customizations?type=removeRater`,
  END_MFS_QUESTIONNAIRE: `${playerApiDomain}/player/shl360/questionnaire/end`,

  // Rater Nomination
  GET_MFS_RATER_SEARCH_FIELDS: isDev
    ? './src/__mockData__/mockSearchfields.json'
    : `${playerApiDomain}/mfs-api/raters/search-fields/`,
  POST_MFS_RATER_NOMINATION_DETAILS: isDev
    ? './src/__mockData__/mfsRaterNominationDetails.json'
    : `${playerApiDomain}/player/shl360/getraternominationdetails/`,
  POST_MFS_ADD_UPDATE_RATER: `${playerApiDomain}/player/shl360/updaterater`,
  POST_MFS_RATER_SEARCH: isDev
    ? './src/__mockData__/mfsSearchRaterResults.json'
    : `${playerApiDomain}/mfs-api/raters/v2/search`,

  POST_MFS_RATER_NOMINATION_END: `${playerApiDomain}/player/shl360/raternomination/done`,
  GET_RATER_NOMINATION_UPDATE_STATUS: `${playerApiDomain}/player/shl360/raternomination/update`,
  GET_SAMPLE_REPORT: './src/__mockData__/James_Stone.pdf',
  POST_SAVE_BIODATA: `${playerApiDomain}/player/shl360/save/biodata`,
  GET_RATER_CUSTOMIZATIONS: isDev
    ? './src/__mockData__/mfsRaterCustomizations.json'
    : `${playerApiDomain}/mfs-api/customizations/settings?type=rating&rid=`,

  GET_RATER_HELP_TEXT: isDev
    ? './src/__mockData__/mfsRaterHelpText.json'
    : `${playerApiDomain}/mfs-api/customizations?type=rnguide`,
};
